export const TRACK_UNATTACHED = 'TRACK_UNATTACHED'
export const LOCAL_TRACKS_ADDED = 'LOCAL_TRACKS_ADDED'
export const LOCAL_TRACKS_FAILED = 'LOCAL_TRACKS_FAILED'
export const PUBLISH_SCREEN_SUCCESS = 'PUBLISH_SCREEN_SUCCESS'
export const PUBLISH_SCREEN_ERROR = 'PUBLISH_SCREEN_ERROR'
export const SET_TRACK_STATUS = 'SET_TRACK_STATUS'
export const SET_SCREENSHARE = 'SET_SCREENSHARE'
export const UNSET_SCREENSHARE = 'UNSET_SCREENSHARE'
